import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export const applyFilterEvents = ({ eventEmitter }: ApiMethodBase) => {
    eventEmitter.emit(Event.applyFilter);
};